module.exports = __webpack_public_path__ + "2d32a60fb47c387fe74c49cf6198b075.png";